import { useEffect, useState } from 'react';
import { EXPENSE_CATEGORIES, formatJMD } from '../../lib/finances';

// Offered when a purchase order is marked Received.
//
// Prompted rather than automatic: a status change firing a write into the
// books can silently double up with an expense entered by hand, and an
// invented expense is harder to notice than a missing one. The amounts are
// pre-filled from the order, so accepting is one click.
export default function ReceivedPrompt({ order, totalJmd, onSkip, onConfirm }) {
  const [category, setCategory] = useState(EXPENSE_CATEGORIES[0]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onSkip();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onSkip]);

  const handleConfirm = async () => {
    setSaving(true);
    setError(null);
    try {
      await onConfirm(category);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="asset-modal-backdrop" onClick={onSkip}>
      <div
        className="version-modal received-prompt"
        role="dialog"
        aria-modal="true"
        aria-label="Record this order as an expense"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="version-modal-head">
          <div>
            <h3>{order.po_number} received</h3>
            <span className="formula-detail-type">
              {order.vendor?.name || 'Vendor'} · {formatJMD(totalJmd)}
            </span>
          </div>
        </header>

        <p className="received-prompt-body">
          Record this in Accounting as an expense? Skip if you've already entered it by hand.
        </p>

        <label className="received-prompt-field">
          Category
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            {EXPENSE_CATEGORIES.map((c) => (
              <option key={c}>{c}</option>
            ))}
          </select>
        </label>

        {error && <p className="po-error">{error}</p>}

        <div className="ingredient-form-actions">
          <button type="button" className="ghost-button" onClick={onSkip} disabled={saving}>
            Skip
          </button>
          <button type="button" className="primary-action" onClick={handleConfirm} disabled={saving}>
            {saving ? 'Adding…' : 'Add expense'}
          </button>
        </div>
      </div>
    </div>
  );
}
